import { ConnectPaypalModalForm } from "./connect-paypal-modal.types";

export const connectPaypalModalForm: ConnectPaypalModalForm = {
  email: "",
};
